import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

interface DispatchStatus {
  dispatched: number;
  kgsBal: number;
  status: string;
  // orderType: string;
}

@Injectable({
  providedIn: 'root'
})
export class DispatchService {

  
  // private apiUrl = "http://localhost:3003/api";
   private apiUrl = "https://lexipackghana.com:3003/api";


  constructor(private http: HttpClient) {}
 
  
 
  // addDispatch(data:any){
  //   return this.http.post(this.apiUrl+'/dispatch',data);
  // }
  addDispatch(data: any, dispatchId: string) {
    // Construct the URL with the dispatchId parameter
    return this.http.post(`${this.apiUrl}/dispatch/${dispatchId}`, data);
  }
  

  getDispatchBydispatchId(dispatchId: string) {
    return this.http.get<DispatchStatus>(`${this.apiUrl}/dispatches/${dispatchId}`);
  }
  getDispatchByPredispatchId(dispatchId: string) {
    return this.http.get<DispatchStatus>(`${this.apiUrl}/previewDispatches/${dispatchId}`);
  }
  
  // Method to call the new endpoint /dispatches/by-id/:dispatchId
  getDispatchBydispatchbyId(dispatchId: string) {
    return this.http.get(`${this.apiUrl}/dispatches/by-id/${dispatchId}`);
  }
  getAllDispatch(){
    return this.http.get(this.apiUrl+'/dispatches');
  }
  getDispatchById(id: string) {
    return this.http.get(this.apiUrl + '/dispatch/' + id);
  }
  
  // getDispatchBydispatchId(dispatchId: string) {
  //   return this.http.get(`${this.apiUrl}/dispatches/${dispatchId}`);
  // }
    // Update Dispatch by dispatchId (PUT)
    updateDispatch(dispatchId: string, data: any) {
      return this.http.put(`${this.apiUrl}/dispatch/${dispatchId}`, data);  // Use /dispatch/:dispatchId endpoint
    }
  
  // updateDispatch(id: string, data: any) {
  //   return this.http.put(this.apiUrl + '/dispatch/' + id, data);
  // }
  deleteDispatch(id: string) {
    return this.http.delete(this.apiUrl + '/dispatch/' + id);
  }
  getGroupDispatches(){
    return this.http.get(this.apiUrl+'/dispatchesGruop');

  }





  // saveDispatch(data: any): Observable<any> {
  //   // POST to create a new manual closure record
  //   return this.http.post(`${this.apiUrl}/addManualClosure`, data);
  // }
  saveDispatch(data: any): Observable<any> {
    // POST to create or update a manual closure record
    return this.http.post(`${this.apiUrl}/addManualClosure`, data);
  }
  
  // Method to fetch all manual closure records
  getAllManualClosures(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/manualClosures`);
  }
  
}